module.exports = __webpack_public_path__ + "img/model-android-v4.caad3b99.png";